import { useRouter } from "next/router";
import CustomButtonWrapper from "../CustomButtonWrapper";
import { LOADING_PAGE } from "../../routes/RouteConstants";
import classes from "./screenError.module.css";
import cx from "classnames";
import { useEffect } from "react";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import { signOut } from "../../services/utils";
import useRedirectionStore from "../../zustandStores/redirectionStore";
import { JhButton } from "designPackages/buttonPackage";
import { getSalesContactNumber } from "utils/getSalesContactNumber";

const getHeading = (info, details, showLogoutButton) => {
  const { recruiterName, recruiterPhoneMasked } = details || {};

  if (
    (info === "LINK_NOT_BELONGS_TO_RECRUITER" ||
      info === "INVALID_INPUT_INVALID_LINK_FOR_RECRUITER" ||
      info === "JOB_IS_ALREADY_BOOSTED") &&
    recruiterPhoneMasked &&
    recruiterName
  ) {
    if (showLogoutButton) {
      return `<span>Please login with (${recruiterName}, ${recruiterPhoneMasked}) to<br/> complete your purchase.</span>`;
    } else {
      return `<span>This payment is for (${recruiterName}, Mobile:${recruiterPhoneMasked}) <br/> Do you want to proceed?</span>`;
    }
  }

  if (
    info === "INVALID_INPUT_LINK_ALREADY_USED" ||
    info === "INVALID_INPUT_EXPIRED_LINK_ID"
  ) {
    return "The link has expired";
  }
  if (info === "JOB_IS_ALREADY_BOOSTED") {
    return "Job boost is already in progress";
  }

  if (info === "JOB_BOOST_LIMIT_REACHED") {
    return "No more job boosts left on this job";
  }
  if (info === "LINK_VALIDATION_FAILED") {
    return "Failed to validate link";
  }
  return "This link isn't for you.";
};

function ScreenError({ info, onInitiateTransaction, showLogoutButton = true }) {
  const { recruiterDetails } = useRedirectionStore(state => ({
    recruiterDetails: state.recruiterDetails
  }));
  useEffect(() => {
    if (info) {
      LogService.log({ name: info, category: "CREDIT_SYSTEM" });
    }
  }, [info]);

  const router = useRouter();
  function action(actn) {
    if (actn === "LOGOUT") {
      LogService.log({ name: `${info}_logout`, category: "CREDIT_SYSTEM" });
      signOut();
      return;
    }
    LogService.log({ name: `${info}_ACTN`, category: "CREDIT_SYSTEM" });
    router.push(LOADING_PAGE);
  }
  function onContactClick(e) {
    const { id } = e.target;
    if (id === "phone") {
      LogService.log(CREDIT_EVENTS.CHECKOUT_ERR_PHONE_CLCKED);
    }
    if (id === "email") {
      LogService.log(CREDIT_EVENTS.CHECKOUT_ERR_EMAIL_CLCKED);
    }
  }
  if (info === "PAYMENT_IN_PROGRESS") {
    return (
      <div
        className={cx(
          "flex flex-col justify-center items-center",
          classes.layout
        )}
      >
        <img src="transaction-pending.svg" alt="Error" />
        <div className={cx(classes.heading, "text-center")}>
          Your previous payment is <br></br>still under progress
        </div>
        <div className={classes.subHeadingRed}>
          <img src="/hire/hand_red.svg" alt="error" />
          Don't retry the payment till we confirm it.
        </div>
        <div className={classes.btnWrapper}>
          <CustomButtonWrapper
            customClass={classes.btn}
            onClick={() => action()}
            content="Back to Home"
          />
        </div>
      </div>
    );
  }

  if (info === "JOB_IS_ALREADY_POSTED") {
    return (
      <div
        className={cx(
          "flex flex-col justify-center items-center",
          classes.layout
        )}
      >
        <img src="posted_error.svg" alt="Error" />
        <div className={classes.heading}>This job is already posted</div>

        <div className={classes.btnWrapper}>
          <CustomButtonWrapper
            customClass={classes.btn}
            onClick={() => action()}
            content="Back to Home"
          />
        </div>
      </div>
    );
  }
  if (
    info === "LINK_NOT_BELONGS_TO_RECRUITER" ||
    info === "INVALID_INPUT_INVALID_LINK_FOR_RECRUITER"
  ) {
    return (
      <div
        className={cx(
          "flex flex-col justify-center items-center",
          classes.layout
        )}
      >
        <img src="link_error.svg" alt="Error" />
        <div
          dangerouslySetInnerHTML={{
            __html: getHeading(info, recruiterDetails, showLogoutButton)
          }}
          className={classes.heading}
        ></div>
        {showLogoutButton ? (
          <>
            <div onClick={onContactClick} className={classes.lightSubHeading}>
              Logout and login with a different account.
            </div>
            <div className={classes.btnWrapper}>
              <CustomButtonWrapper
                customClass={classes.btn}
                onClick={() => action("LOGOUT")}
                content="Log out"
              />
            </div>
          </>
        ) : (
          <div className={classes.btnWrapper}>
            <CustomButtonWrapper
              customClass={classes.btn}
              onClick={onInitiateTransaction}
              content="Yes"
            />
          </div>
        )}
      </div>
    );
  }

  if (
    info == "INVALID_INPUT_LINK_ALREADY_USED" ||
    info == "INVALID_INPUT_EXPIRED_LINK_ID" ||
    info == "JOB_IS_ALREADY_BOOSTED" ||
    info === "JOB_BOOST_LIMIT_REACHED" ||
    info === "LINK_VALIDATION_FAILED"
  ) {
    const errorImage =
      info == "JOB_IS_ALREADY_BOOSTED" ? "boost_error.svg" : "link_error.svg";
    const salesContactNumber = getSalesContactNumber();
    return (
      <div
        className={cx(
          "flex flex-col justify-center items-center",
          classes.layout
        )}
      >
        <img src={`/hire/${errorImage}`} alt="Error" />
        <div className={classes.heading}>{getHeading(info)}</div>
        <div onClick={onContactClick} className={classes.lightSubHeading}>
          Please feel free to reach out to{" "}
          <a
            id="phone"
            className={classes.blue}
            href={`tel:${salesContactNumber}`}
            target="_blank"
            rel="noreferrer"
          >
            {salesContactNumber}
          </a>
          {"  "}
          or email us at{" "}
          <a
            id="email"
            className={classes.blue}
            href="mailto:sales@jobhai.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            sales@jobhai.com
          </a>{" "}
          if you need help in purchasing credits.
        </div>
        <div className={classes.btnWrapper}>
          <CustomButtonWrapper
            customClass={classes.btn}
            onClick={() => action()}
            content="Back to Home"
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className={cx(
        "flex flex-col justify-center items-center",
        classes.layout
      )}
    >
      <img src="screen_error.svg" alt="Error" />
      <div className={classes.heading}>Something went wrong</div>
      <div className={classes.subHeading}>Please try again later</div>
      <div className={classes.btnWrapper}>
        <JhButton size="sm" onClick={() => router.push(LOADING_PAGE)}>
          Back to Home
        </JhButton>
      </div>
    </div>
  );
}

export default ScreenError;
